import { render, staticRenderFns } from "./SupportingDocuments.vue?vue&type=template&id=2b73ec87&scoped=true&"
import script from "./SupportingDocuments.vue?vue&type=script&lang=js&"
export * from "./SupportingDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b73ec87",
  null
  
)

export default component.exports